module.exports = __webpack_public_path__ + "img/faq-big.c0e321f2.svg";